var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import MapboxGL from 'mapbox-gl';
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Map extends Component {
    constructor() {
        super('MapManger', false);
        this.accessToken = 'pk.eyJ1Ijoicm9zZWx5bmVqYXJkaW5zIiwiYSI6ImNsdDVya2hxcjA0MmQya3Fyand1NGxqcTAifQ.cSae49-bQKawICdXG22qAg';
        $('#btn-close-panel').on('click', () => this.closePanel());
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            this.createMap();
            const highlightedPlaceId = $('#map').data('hightlightId');
            this.data = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    action: 'get_places',
                },
                dataType: 'json'
            });
            try {
                this.map.addSource('places', {
                    type: 'geojson',
                    data: this.data,
                    cluster: true,
                    clusterMaxZoom: 15,
                    clusterRadius: 50
                });
                this.map.addLayer({
                    id: 'clusters',
                    type: 'circle',
                    source: 'places',
                    filter: ['has', 'point_count'],
                    paint: {
                        'circle-color': '#fff',
                        'circle-radius': 17,
                        'circle-stroke-width': 1,
                        'circle-stroke-color': '#000',
                    }
                });
                this.map.addLayer({
                    id: 'clusters-text',
                    type: 'symbol',
                    source: 'places',
                    filter: ['has', 'point_count'],
                    layout: {
                        'text-field': '...',
                        'text-font': ['Riforma LL Regular', 'Arial Unicode MS Regular'],
                        'text-size': 16,
                    },
                    paint: {
                        'text-color': '#000'
                    }
                });
                this.map.addLayer({
                    id: 'places',
                    type: 'circle',
                    source: 'places',
                    filter: ['!', ['has', 'point_count']],
                    paint: {
                        'circle-color': [
                            'case',
                            ['boolean', ['get', 'highlighted'], true],
                            '#7bfa3b',
                            ['==', ['get', 'type'], 'garden'],
                            '#fff',
                            ['==', ['get', 'type'], 'event'],
                            '#5637ff',
                            '#000'
                        ],
                        'circle-radius': [
                            'case',
                            ['boolean', ['feature-state', 'hover'], false],
                            28,
                            ['boolean', ['get', 'highlighted'], true],
                            28,
                            17
                        ],
                        'circle-stroke-width': 1,
                        'circle-stroke-color': '#000',
                    }
                });
                this.map.addLayer({
                    id: 'places-title',
                    type: 'symbol',
                    source: 'places',
                    filter: ['!=', ['get', 'type'], 'service'],
                    layout: {
                        'text-field': ['get', 'code'],
                        'text-font': ['Arial Unicode MS Regular'],
                        'text-size': 16,
                    },
                    paint: {
                        'text-color': [
                            'case',
                            ['boolean', ['get', 'highlighted'], true],
                            '#000',
                            ['==', ['get', 'type'], 'garden'],
                            '#5637ff',
                            ['==', ['get', 'type'], 'event'],
                            '#fff',
                            '#000'
                        ]
                    }
                });
                this.map.addLayer({
                    id: 'places-icons',
                    type: 'symbol',
                    source: 'places',
                    filter: ['==', ['get', 'type'], 'service'],
                    layout: {
                        'icon-image': ['get', 'icon'],
                        'icon-size': 1,
                        'icon-allow-overlap': true,
                        'icon-ignore-placement': true,
                    }
                });
                // Hover on cluster
                this.map.on('mouseenter', ['clusters', 'unclustered-point'], (e) => {
                    this.map.getCanvas().style.cursor = 'pointer';
                });
                this.map.on('mouseleave', ['clusters', 'unclustered-point'], () => {
                    this.map.getCanvas().style.cursor = '';
                });
                // Hover on places
                let quakeID = null;
                this.map.on('mousemove', 'places', (event) => {
                    if (event.features.length === 0)
                        return;
                    this.map.getCanvas().style.cursor = 'pointer';
                    if (quakeID)
                        this.map.removeFeatureState({ source: 'places', id: quakeID });
                    quakeID = event.features[0].id;
                    this.map.setFeatureState({ source: 'places', id: quakeID }, { hover: true });
                });
                this.map.on('mouseleave', 'places', () => {
                    if (quakeID)
                        this.map.setFeatureState({ source: 'places', id: quakeID }, { hover: false });
                    quakeID = null;
                    this.map.getCanvas().style.cursor = '';
                });
                // Click on cluster
                this.map.on('click', 'clusters', (e) => {
                    const features = this.map.queryRenderedFeatures(e.point, {
                        layers: ['clusters']
                    });
                    const clusterId = features[0].properties.cluster_id;
                    this.map.getSource('places').getClusterExpansionZoom(clusterId, (err, zoom) => {
                        if (err)
                            return;
                        this.map.easeTo({
                            center: features[0].geometry.coordinates,
                            zoom: zoom
                        });
                    });
                });
                // Click on places
                this.map.on('click', 'places', (e) => {
                    const coordinates = e.features[0].geometry.coordinates.slice();
                    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                    }
                    this.openPanel(e.features[0].id);
                });
                //if (highlightedPlaceId) this.openPanel(highlightedPlaceId);
                // Move map to place
                if (highlightedPlaceId)
                    this.zoomToPlace(highlightedPlaceId);
            }
            catch (error) {
                console.error(error);
            }
            this.success();
        });
    }
    createMap() {
        MapboxGL.accessToken = this.accessToken;
        // Initialize the map
        this.map = new MapboxGL.Map({
            container: $('#map').get(0),
            style: 'mapbox://styles/roselynejardins/clt460kyb00on01quc3jag0bu',
            center: [6.620087, 46.515487],
            zoom: 12,
            scrollZoom: true,
            minZoom: 9
        });
        // Set controls
        this.map.addControl(new MapboxGL.GeolocateControl({ positionOptions: { enableHighAccuracy: true }, trackUserLocation: false, showUserHeading: false }), 'bottom-left');
        this.map.addControl(new MapboxGL.NavigationControl({ showCompass: false }), 'bottom-left');
        // Fit map to Lausanne
        this.map.fitBounds([
            [6.580902, 46.502340],
            [6.632202, 46.520733]
        ], { duration: 0 });
    }
    /*
     * Zoom to place
     */
    zoomToPlace(id) {
        this.data.features.forEach((feature) => {
            feature.properties.highlighted = feature.id == id;
        });
        this.map.getSource('places').setData(this.data);
        // Move map to place
        this.map.easeTo({
            center: this.data.features.find((feature) => feature.id == id).geometry.coordinates,
            zoom: 16
        });
    }
    /*
     * Open panel
     */
    openPanel(id) {
        return __awaiter(this, void 0, void 0, function* () {
            // Set highlighted
            this.zoomToPlace(id);
            setTimeout(() => {
                $('#loading').removeClass('d-none').addClass('d-flex');
            }, 500);
            yield new Promise((resolve) => setTimeout(resolve, 500));
            // if panel is opened, close it
            if ($('#panel').hasClass('is-opened'))
                $('#panel').removeClass('is-opened');
            // Load panel
            const response = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    action: 'get_panel',
                    id: id
                },
                dataType: 'html'
            });
            // Show panel
            $('#panel').addClass('is-opened');
            $('.panel-content').empty().append(response);
            $('.card-thumbnail').css('background-image', 'url(\'' + $('.card-thumbnail').data('hwBackgroundImage') + '\')');
            $('#loading').addClass('d-none').removeClass('d-flex');
        });
    }
    /*
     * Close panel
     */
    closePanel() {
        $('#panel').removeClass('is-opened');
        this.data.features.forEach((feature) => {
            feature.properties.highlighted = false;
        });
        this.map.getSource('places').setData(this.data);
    }
}
